import { __awaiter } from "tslib";
import { useGetUserProfileQuery } from '@websky/graphql';
import { currentUserFactory } from './utils';
import { useConfig } from '../context';
export const WEBSKY_CURRENT_USER = 'webskyCurrentUser';
export const useCurrentUser = (skip) => {
    var _a, _b, _c, _d;
    const currentUserInGlobalScope = (_b = (_a = useConfig()) === null || _a === void 0 ? void 0 : _a.global) === null || _b === void 0 ? void 0 : _b.currentUserInGlobalScope;
    const usePixel = (_d = (_c = useConfig()) === null || _c === void 0 ? void 0 : _c.global) === null || _d === void 0 ? void 0 : _d.usePixel;
    const shouldSkip = skip !== null && skip !== void 0 ? skip : !(currentUserInGlobalScope || usePixel);
    const onCompleted = (data) => {
        if (!(data === null || data === void 0 ? void 0 : data.CurrentUser)) {
            return;
        }
        const userData = currentUserFactory(data.CurrentUser);
        const event = new CustomEvent(WEBSKY_CURRENT_USER, {
            detail: userData
        });
        window[WEBSKY_CURRENT_USER] = userData;
        document.dispatchEvent(event);
    };
    const { data, refetch, loading } = useGetUserProfileQuery({
        fetchPolicy: 'no-cache',
        skip: shouldSkip,
        onCompleted
    });
    const reinitialize = () => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield refetch();
        onCompleted(data === null || data === void 0 ? void 0 : data.data);
    });
    return {
        data,
        loading,
        reinitialize
    };
};
